import { Berufsrisikogruppe as BerufsrisikogruppeBFF, Produktlinienname } from '@ps20/bff-models';

export enum Berufsrisikogruppe {
  KAUFMAENNISCH = BerufsrisikogruppeBFF.A,
  HANDWERKLICH = BerufsrisikogruppeBFF.B,
  PROFISPORTLER = BerufsrisikogruppeBFF.P,
  ARTIST_STUNTMAN_DOMPTEUR = 8383,
}

export function getBerufsrisikogruppeByValue(enumValue: string): Berufsrisikogruppe {
  switch (enumValue) {
    case 'A':
      return Berufsrisikogruppe.KAUFMAENNISCH;
    case 'B':
      return Berufsrisikogruppe.HANDWERKLICH;
    case '8383':
      return Berufsrisikogruppe.ARTIST_STUNTMAN_DOMPTEUR;
    case 'P':
      return Berufsrisikogruppe.PROFISPORTLER;
    default:
      throw new Error('Invalid Berufsrisikogruppe value.');
  }
}

export enum UnfFachschluessel {
  LEISTUNG_AB = 'UE000242',
  INV_SUMME = 'UE000240',
  MAX_LEISTUNG = 'UE000241',
  TOPSCHUTZ = 'UE000243',
  TODESFALL = 'UE000251',
  MONATLICHEUNFALLRENTE = 'UE000252',
  KRANKENHAUSTAGEGELD = 'UE000258',
  KINDERINVALIDITAET = 'UE000250',
  RUNDUMSERVICE = 'UE000271',
  AKKUTLEISTUNG = 'UE000267',
  ASSISTANCE = 'UE000292',
  ASSISTANCETHERAPIE = 'UE000293',
}

export const UnfallProduktlinienname = {
  ...Produktlinienname,
  KUS_5th_SAEULE: 'KUS_5th_SAEULE',
};

/**
 * Types of special sport risk categories
 */
export enum SpecialSportRiskType {
  PROFESSIONAL_ATHLETE = 'PROFESSIONAL_ATHLETE',
  // Future: ARTIST_STUNTMAN = 'ARTIST_STUNTMAN', etc.
}
